import { useRelatedTasksTabStore } from '../../../../../store/strategy-store/strategy-store';
import { RelatedTasksMode } from '../related-tasks-tab.type';
import { FiltersEpics } from './filters-epics';
import { FiltersTasks } from './filters-tasks';
import { FiltersTeams } from './filters-teams';

export const FiltersList = () => {
  const mode = useRelatedTasksTabStore((state) => state.mode);

  switch (mode) {
    case RelatedTasksMode.ContributingTasks:
      return <FiltersTasks />;
    case RelatedTasksMode.ContributingEpics:
      return <FiltersEpics />;
    case RelatedTasksMode.ContributingTeams:
      return <FiltersTeams />;
    default:
      return null;
  }
};
